import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent {
  constructor(title: Title, meta: Meta) {
    title.setTitle('Pixel Pro');
    meta.addTags([
      {
        name: 'description',
        content:
          'Discover expertly crafted software solutions tailored to elevate your business.',
      },
      {
        name: 'keywords',
        content: 'Pixel Pro, Restaurant System, POS',
      },
    ]);
  }
}
